<template>
  <div id="intro-3" class="intro-box">
    <div class="intro-box__wrapper">
      <div class="intro-box__header">
        <h3>Commission Configuration</h3>
      </div>

      <div class="intro-box__content">
        <p>To calculate how much commission you will owe to your vendors we will need a little
          information.</p>

        <p><small>*You can always change these in the settings later.</small></p>
      </div>
    </div>

    <div class="intro-box__footer">
      <button class="button--wide" @click="changeStep()">Start Configuration</button>

<!--      <div class="intro-box__skip">configure later</div>-->
    </div>

    <div class="intro-box__pagination">
      <span></span>
      <span></span>
      <span class="active"></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    changeStep (next = true) {
      this.$emit('changeStep', next)
    }
  }
}
</script>

<style lang="scss">
  @import '../../../styles/mixins';
  @import '../../../styles/variables';
</style>



// WEBPACK FOOTER //
// src/apps/vendorconsignment/tutorials/step3.vue